/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptionalReasonRequest
 */
export interface OptionalReasonRequest {
    /**
     * 
     */
    reason?: string;
}

/**
 * Check if a given object implements the OptionalReasonRequest interface.
 */
export function instanceOfOptionalReasonRequest(value: object): value is OptionalReasonRequest {
    return true;
}

export function OptionalReasonRequestFromJSON(json: any): OptionalReasonRequest {
    return OptionalReasonRequestFromJSONTyped(json, false);
}

export function OptionalReasonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionalReasonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function OptionalReasonRequestToJSON(json: any): OptionalReasonRequest {
    return OptionalReasonRequestToJSONTyped(json, false);
}

export function OptionalReasonRequestToJSONTyped(value?: OptionalReasonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

